<template>
  <div id="app" :class="pageClassName">
    <classroomHeader
      v-if="classRoomHeaderShow"
      :loginInfo="loginInfo"
      :user="uPlusUser"
      @change-org="changeOrg"
      :curPath="curPagePath"
    ></classroomHeader>
    <header-Component
      v-if="showHeader&&!classRoomHeaderShow"
      :loginInfo="loginInfo"
      :user="uPlusUser"
      @change-org="changeOrg"
      :class="{'home-header-position': homeHeaderPosition}"
      ref="commonHeaderRef"
    ></header-Component>
    <div
      class="main-page-wrapper"
      :class="{ 'main-workOrder-wrapper': workOrderShow }"
      v-if="isFrontView"
      :style="{ background: bgColor }"
    >
      <router-view v-if="isShow"></router-view>
    </div>
    <div
      :class="[
        'main-noPad-wrapper',
        { 'forget-active': forgetShow, 'main-page-wrapper': loginOrRegist }
      ]"
      v-else
    >
      <router-view v-if="isShow"></router-view>
    </div>

    <!-- <front-side-bar></front-side-bar> -->
    <!-- 首页登录弹窗开始 -->
    <div v-if="isFrontView && guideShow && loginShow && !workOrderShow">
      <div class="mask"></div>
      <div class="login-guide slide">
        <img src="~@/assets/login/activity.png" />
        <img
          @click="goLogin"
          class="login-btn"
          src="~@/assets/login/login.png"
          alt
        />
        <i
          class="iconfont iconCombinedShape1 login-guide-close"
          @click="closeLoginGuide"
        ></i>
        <!-- <div class="login-guide-close" @click="closeLoginGuide"></div> -->
      </div>
    </div>

    <!-- 更新弹窗start -->
    <!-- 模态框 -->
    <div v-if="closeUpdateBox">
      <div class="mask"></div>
      <div class="update-box slide">
        <img src="~@/assets/updateWindow/update.png" width="480" height="226" />
        <p class="title">本次更新</p>
        <ol v-html="platformAnnouncementInfo.content"></ol>
        <div class="confirm-btn">
          <span @click="confirmCurUpdate">我知道了</span>
        </div>
      </div>
    </div>
    <div style="position: relative; z-index: 2" v-if="showFooter">
      <page-footer></page-footer>
    </div>
    <back-to-top :user="uPlusUser" ref="backtotopBox" :custCareShow="!hideCustCare">
      <div slot="after" v-show="isProductSolution && uPlusUser.isLogin == '1'">
        <div
          title="问题反馈"
          style="
            margin: 0px 0 14px auto;
            width: 40px;
            height: 40px;
            border-radius: 5px 0 0 5px;
            cursor: pointer;
            text-align: center;
            background-color: #c4c4c4;
            pointer-events: all;
          "
          @click="fnEditFeedback"
        >
          <img
            src="./assets/icons/edit.png"
            width="23"
            height="23"
            style="margin-top: 7px"
          />
        </div>
      </div>
    </back-to-top>
    <CompFeedback ref="feedbackFrom"></CompFeedback>
    <agreement-tip v-if="uPlusUser.id"></agreement-tip>
  </div>
</template>
<script>
const { HeaderComponent, BackToTop, agreementTip, classroomHeader } =
  window['openplat-header'].default
import { removeTicket, isDuringDate } from '@/utils'
import CompFeedback from './views/productSolution/compFeedback'
import {
  getPlatformAnnouncement,
  postCurPlatformAnnouncement,
  confirmPhoMall,
  readPhoMall
} from '@/api/indexApi'
import { login, isLogin, CASLoginAPI, updateUserByHsAccount } from '@/api/login'
import { addUserAnalysis, config, isSignUplusAgreement } from '@/api/service'
import Fingerprint from 'fingerprintjs'
import { mapGetters } from 'vuex'
import trackMixin from '@/components/mixins/track.js'
import Track from '@/utils/track'
// import { isLoginJson, CASLoginAPI } from "@/api/login.js";
import Axios from 'axios'
import _ from 'lodash'
const { PageFooter } = window.openplatWebCommon.default
export default {
  name: 'app',
  data() {
    return {
      showHeader: true,
      isProductSolution: false,
      timer: '',
      urlEnum: {
        '/developerConference/ticketing': '2021LIGHT-PC-购票页面',
        '/developerConference/ticketing2': '2021LIGHT-PC-购票页面-填写信息页面',
        '/developerConference/ticketing3': '2021LIGHT-PC-购票页面-支付页面',
        '/developerConference/paySuccess': '2021LIGHT-PC-购票页面-支付状态',
        '/developerConference/signInCode': '2021LIGHT-PC-签到码',
        '/developerConference/conferenceIndex': '2021LIGHT-PC-开发者大会主页',
        '/developerConference/meetingAgenda': '2021LIGHT-PC-大会议程专题页',
        '/developerConference/guests': '2021LIGHT-PC-嘉宾页',
        '/developerConference/mainForum': '2021LIGHT-PC-主论坛专题页',
        '/developerConference/subForum': '2021LIGHT-PC-分论坛专题页'
      },
      url_name: '',
      isShow: true,
      clientHeight: 0,
      isFrontView: false,
      forgetShow: false,
      loginShow: true,
      loginOrRegist: false,
      start_time: '',
      end_time: '',
      sideBarShow: false,
      // 公告信息
      platformAnnouncementInfo: { content: '', serial_num: '', display: 0 },
      photonUrl: window.LOCAL_CONFIG.PHOTON_URL,
      closeUpdateBox: false,
      workOrderShow: false,
      // addBg: false //给头部栏加底色
      pathFeedBack: [
        '/productList',
        '/productModule',
        '/productDetail',
        '/solutionList',
        '/solutionDetail'
      ],
      pageClassName: '', // 不同路由自定义的页面类名
      curPagePath: '', // 当前页面地址
      showFooter: false,
      classRoomHeaderShow: false, // 是否展示课堂头部
    }
  },
  mixins: [trackMixin],
  provide() {
    return {
      reload: this.reload
    }
  },
  components: {
    PageFooter,
    HeaderComponent,
    BackToTop,
    CompFeedback,
    agreementTip,
    classroomHeader
  },
  computed: {
    ...mapGetters(['loginInfo', 'user', 'uPlusUser', 'isCloud']),
    guideShow() {
      // return isDuringDate("2020-11-25 00:00:00", "2020-12-26 23:59:59")
      return isDuringDate(this.start_time, this.end_time)
    },
    murmur() {
      return new Fingerprint().get()
    },
    hideCustCare() {
      return this.$route.meta.hideCustCare || false
    },
    homeHeaderPosition() {
      return this.$route.meta.isHomePage || false
    },
  },
  watch: {
    closeUpdateBox: {
      handler(v) {
        this.noScrollWindow(v)
      }
      // immediate: true
    },
    $route(to, from) {
      this.pageClassName = to.meta.pageClassName || ''
      this.curPagePath = to.path

      // 产品与解决方案的私有功能
      if (this.pathFeedBack.indexOf(to.path) >= 0) {
        this.isProductSolution = true
      } else {
        this.isProductSolution = false
      }
      this.classRoomHeaderShow = to.meta.classRoomHeaderShow // 是否展示课堂头部
      /* 在线课堂——考试中心特殊处理 */
      //考试和考试结果页面不展示头部
      if (
        to.path.indexOf('/examAnswer') > -1 ||
        to.path.indexOf('/examDetail') > -1 ||
        to.path.indexOf('/examResult') > -1 ||
        to.path.indexOf('/courseSearchResult') > -1
      ) {
        this.showHeader = false
      }

      /* 在线课堂——考试中心特殊处理 */
      // 活动答题结果页面不展示底部组件
      if (to.path.indexOf('/contestExamResult') > -1) {
        this.showFooter = false
      } else {
        this.showFooter = true
      }

      // 头部样式在技术争霸赛页面是白色文字，所以这里针对competition路径给body增加一个类名，以便控制样式
      const bodyClassName = document.body.className
      if (to.path.indexOf('/competition') > -1) {
        document.body.className = bodyClassName + ' competition-page'
      } else {
        document.body.className = bodyClassName.replace(' competition-page', '')
      }
      if (to.path.indexOf('/financial-competition') > -1) {
        document.body.className =
          document.body.className + ' financial-competition-page'
      } else {
        document.body.className = document.body.className.replace(
          ' financial-competition-page',
          ''
        )
      }

      if (to.name == '首页' && this.user.hsid) {
        this.queryPlatformAnnouncement()
        isSignUplusAgreement().then((res) => {
        })
      } else if (to.name == '首页') {
        // this.confirmPhotonIsShow();
      } else {
        this.closeUpdateBox = false
      }
      this.bgColor = this.$route.name
        ? this.$route.name.replace(' ', '') == 'home'
          ? '#fff'
          : '#f3f7fe'
        : ''
      this.bgColor =
        to.matched[0].path == '/workOrder' ? '#ffffff' : this.bgColor
      this.forgetShow = to.name == '忘记密码' ? true : false
      this.loginOrRegist =
        to.name == '登录' || to.name == '注册' || to.name == '注册成功'
          ? true
          : false
      this.workOrderShow = to.matched[0].path == '/workOrder' ? true : false
      this.sideBarShow = to.meta.sideBar == false ? false : true
      this.isFrontView = to.meta.header ? true : false

      let that = this
      clearInterval(that.timer)
      let url = to.fullPath
      that.url_name = that.urlEnum[url]
      that.sendMessage(1)
      let timer = setInterval(function () {
        that.sendMessage(30)
      }, 30000)
    }
  },
  created() {
    this._bus.$on('callChangeAccountShow', (ids = []) => {
      this.$refs.commonHeaderRef.changeAccount(ids)
    })
  },
  mounted() {
    this.$hMessage.config({
      top: 30
    })
    // setTimeout(() => {
    //   this.replaceTicket()
    // }, 1000)
    // this.confirmLogin();
    // 监听滚动给头部导航栏加上底色
    // window.addEventListener("scroll", _.debounce(this.handleScroll, 500), true);
  },
  methods: {
    changeOrg() {
      this.$setUplusUser()
      this.reload()
    },
    // replaceTicket() {
    //   const url = window.location.href
    //   if (url.indexOf('ticket') > -1) {
    //     history.replaceState(null, null, removeTicket(url))
    //   }
    // },
    // 获取域账号对应的账户名和部门
    getHsAccount(domain_account) {
      let jumpUrl2 = `${window.LOCAL_CONFIG.jumpUrl}/oimsinner/getEmployeDepatment.htm?domain_account=${domain_account}`
      Axios({
        url: jumpUrl2
      }).then((res) => {
        let info = res.data
        updateUserByHsAccount(info)
      })
    },
    // 确认更新内容
    confirmCurUpdate() {
      postCurPlatformAnnouncement({
        serial_num: this.platformAnnouncementInfo.serial_num
      }).then((res) => {
        this.closeUpdateBox = false
      })
    },

    // 获取系统公告
    queryPlatformAnnouncement() {
      return new Promise((resolve, reject) => {
        getPlatformAnnouncement({ type_name: '系统公告' }).then((res) => {
          try {
            if (res) {
              // 后台返回的内容进行处理
              let contentDatas = res.content
                .split('<ol>')[1]
                .split('</ol>')[0]
                .split('<li>')
              let str = ''
              for (
                let i = contentDatas.length > 10 ? 10 : contentDatas.length - 1;
                i > 0;
                i--
              ) {
                if (i > 0) {
                  contentDatas[i] =
                    `<div><span style="float:left;margin-top: 2px">${i}</span><li style="display:flex">` +
                    contentDatas[i] +
                    '</div>'
                  str = contentDatas[i] + str
                }
              }
              this.platformAnnouncementInfo.content = str
              this.platformAnnouncementInfo.serial_num = res.serial_num
              this.closeUpdateBox = true
              resolve(false)
            } else {
              this.closeUpdateBox = false
              resolve(true)
            }
          } catch (e) {}
        })
      })
    },
    goLogin() {
      // this.handleTrack("PC_登录引导点击量_登录");
      localStorage.setItem('backUrl', window.location.href)
      this.$goLoginUrl()
    },
    // 关闭登录引导
    closeLoginGuide() {
      this.loginShow = false
      // this.handleTrack("PC_登录引导点击量_关闭");
    },
    // 获取活动的开始时间，结束时间
    getActivityConfig(code) {
      config(code).then((res) => {
        this.start_time = res.start_time
        this.end_time = res.end_time
      })
    },
    // bodyClick() {
    //   if (this.$refs.headerBar) {
    //     this.$refs.headerBar.searchExpand = false;
    //   }
    //   if (this.$refs.cloudHeaderBar) {
    //     this.$refs.cloudHeaderBar.searchExpand = false;
    //   }
    // },
    getClientHeight() {
      let clientHeight = 0
      if (document.body.clientHeight && document.documentElement.clientHeight) {
        clientHeight =
          document.body.clientHeight < document.documentElement.clientHeight
            ? document.body.clientHeight
            : document.documentElement.clientHeight
      } else {
        clientHeight =
          document.body.clientHeight > document.documentElement.clientHeight
            ? document.body.clientHeight
            : document.documentElement.clientHeight
      }
      return clientHeight
    },
    sendMessage(t) {
      let params = {}
      //获取当前的url地址
      params.url = window.location.href
      //获取在当前页面停留时间
      params.residence_time = t
      //获取浏览器指纹
      if (localStorage.getItem('browserId')) {
        params.browser_fingerprint = localStorage.getItem('browserId')
      } else {
        // this.getFinger();
        params.browser_fingerprint = localStorage.getItem('browserId')
      }
      params.url_name = this.url_name
    },
    // getLogin() {
    //   isLogin().then(res => {
    //     if (res.login == true) {
    //       this.$setUplusUser();
    //       this.loginShow = false;
    //       this.$store.commit("SET_USER", res);
    //       this.userInfo = res["user"];
    //       // let backUrl = localStorage.getItem('backUrl')
    //       // backUrl = backUrl.indexOf('/login') !== -1 ? window.location.origin : backUrl
    //       let obj = { method: "loginSync" };
    //       window.parent.postMessage(obj, "*");
    //       history.replaceState(
    //         null,
    //         null,
    //         window.location.href
    //           .replace(/(\?)ticket=([^&#]*)([&#]|$)/, "")
    //           .replace(/(&)ticket=([^&#]*)([&#]|$)/, "&")
    //           .replace(/CASTGC=([^&#]*)([&#]|$)/, "")
    //           .replace(/(&)CASTGC=([^&#]*)([&#]|$)/, "&")
    //       );
    //     }
    //   });

    //   // .catch(res => {})
    // },
    // getFinger(){
    //   Fingerprint2.get((components) => {
    //         const values = components.map(component => component.value);
    //         const murmur = Fingerprint2.x64hash128(values.join(''), 31);
    //         localStorage.setItem('browserId', murmur); // 存储浏览器指纹，在项目中用于校验用户身份和埋点
    //   });
    // }
    getFinger() {
      localStorage.setItem('browserId', this.murmur)
    },
    reload() {
      this.isShow = false
      this.$nextTick(function () {
        this.isShow = true
      })
    },
    fnEditFeedback() {
      this.$refs['feedbackFrom'].openCheckIn()
    }
  }
}
</script>
<style lang="scss">
body,
html,
#app {
  height: 100%;
  font-family: Arial, 'Microsoft Yahei', sans-serif, Verdana, 'PingFang SC';
}

::-webkit-scrollbar {
  width: 8px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.3);
}

::-webkit-scrollbar-arrow {
  color: red;
  background: #0f0;
}

// 当高度不满一屏幕的时候给头部导航栏加高度
// .cancel-fixed {
//   position: relative !important;
//   background-color: #fff;
// }
.sb-content-1 img {
  max-width: 100%;
}
.home-header-position {
  position: absolute;
  top: 0;
  width: 100%;
  min-width: 1200px;
  .header-wrapper {
    background: rgba(248,250,255,0.40) !important;
  }
  .h-modal-mask + .header-wrapper {
    background-color: rgb(248, 250, 255) !important;
  }
}

.main-page-wrapper {
  min-width: 1200px;
  background: #fff;
}

.main-noPad-wrapper {
  min-width: 1200px;
  // height: 100%;
  //padding-top: 80px;
  //background: #f3f7fe;
}

.forget-active {
  background: #ffffff;
}

.mask {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  opacity: 0.6;
}

// 登录弹窗更新弹窗公共样式
.box-common {
  z-index: 102;
  position: fixed;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 480px;
}

.guanzi-box {
  top: 50%;
  z-index: 102;
  position: fixed;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;

  .go-photon {
    display: inline-block;
    width: 234px;
    height: 60px;
    background-image: linear-gradient(270deg, #1e4eff 0%, #0036ff 100%);
    border-radius: 24px;
    font-size: 18px;
    color: #ffffff;
    line-height: 60px;
    font-weight: 600;
  }

  img {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    image-rendering: -moz-crisp-edges;
    /* Firefox */
    image-rendering: -o-crisp-edges;
    /* Opera */
    image-rendering: -webkit-optimize-contrast;
    /*Webkit (non-standard naming) */
    image-rendering: crisp-edges;
    -ms-interpolation-mode: nearest-neighbor;
    /* IE (non-standard property) */
  }

  .close-btn {
    position: absolute;
    top: 0px;
    right: 20px;
    cursor: pointer;
  }
}

.update-box {
  top: calc(50% + 60px);
  border-radius: 16px;
  background-color: #fff;
  @extend .box-common;

  img {
    margin-top: -152px;
    margin-bottom: 8px;
  }

  .title {
    font-family: Alibaba-PuHuiTi-M;
    color: #333333;
    font-size: 24px;
    margin-bottom: 24px;
    letter-spacing: 0;
    text-align: center;
    line-height: 30px;
  }

  ol {
    padding-left: 50px;
    padding-right: 42px;
    max-height: 168px;
    overflow-y: auto;
    margin-bottom: 44px;
    margin-right: 8px;

    &::-webkit-scrollbar-track {
      background: #f7f7f7;
      border-radius: 6px;
    }

    span {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #333333;
      display: inline-block;
      width: 20px;
      height: 20px;
      border-radius: 20px;
      text-align: center;
      line-height: 20px;
      background: rgba(48, 96, 255, 0.1);
      margin-right: 8px;
    }

    li {
      font-size: 16px;
    }
  }

  .confirm-btn {
    text-align: center;
    margin-bottom: 47px;

    span {
      display: inline-block;
      width: 120px;
      height: 30px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #ffffff;
      cursor: pointer;
      line-height: 30px;
      background: #3060ff;
    }
  }
}

.login-guide {
  @extend .box-common;
  top: 50%;
  height: 450px;

  // background: url("~@/assets/login/activity.png") center center no-repeat;
  // background-size: contain;
  img:first-child {
    width: 100%;
    position: relative;
  }

  .login-btn {
    width: 178px;
    height: 45px;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, -30px);
    cursor: pointer;
  }
}

.login-guide-close {
  z-index: 102;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(205px, -215px);
  width: 24px;
  height: 24px;
  background: url('~@/assets/login/close.png') center center no-repeat;
  background-size: contain;

  &:hover {
    cursor: pointer;
  }
}

@keyframes slidemove {
  0% {
    -webkit-transform: translate3d(0, 100%, 0);
    visibility: visible;
    transform: translate(-50%, 0);
  }

  100% {
    transform: translate(-50%, -50%);
  }
}

.slide {
  animation: slidemove 0.5s cubic-bezier(0.1, 0.63, 0.43, 0.96) forwards;
}

body {
  background: #f3f7fe;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
    visibility: hidden;
  }

  to {
    opacity: 1;
    transform: none;
    visibility: visible;
  }
}

.animate__fadeIn {
  animation: fadeIn 300ms linear forwards;
}

@keyframes fadeOut {
  0% {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

.animate__fadeOut {
  animation: fadeOut 300ms linear forwards;
}

@keyframes slideInRight {
  0% {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
    visibility: visible;
  }

  to {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

.animate__slideInRight {
  animation: slideInRight 500ms linear;
}

@keyframes slideOutLeft {
  0% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }

  to {
    visibility: hidden;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
}

.animate__slideOutLeft {
  animation: slideOutLeft 800ms linear;
}

.animating-enter-down {
  -webkit-animation: re-banner-slide-20 0.8s cubic-bezier(0.4, 0, 0.2, 1) 0s 1
    forwards;
  animation: re-banner-slide-20 0.8s cubic-bezier(0.4, 0, 0.2, 1) 0s 1 forwards;
}

@keyframes re-banner-slide-20 {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 20px, 0);
    transform: translate3d(0, 20px, 0);
  }

  100% {
    opacity: 1;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/App.vue